<template>
  <div class="message-box">
    <b-modal ref="modal-window" :title="message" size="lg modal-fullscreen-xxl-down" modal-class="message-box-modal" :loading="loading">
        <template #modal-body>
          <text-field
              v-model="form.first_name"
              required
              :error="v$.form.first_name.$error ? $t('client.error.first_name') : ''"
              :label="$t('client.first_name')"
          />

          <text-field
              v-model="form.last_name"
              :label="$t('client.last_name')"
          />

          <text-field
              v-model="form.phone"
              required
              :placeholder="'+371'"
              :infoTooltipLabel="$t('client.phone-tooltip')"
              :error="v$.form.phone.$error && v$.form.phone.$errors ? $t(v$.form.phone.$errors[0].$uid) : ''"
              :label="$t('client.phone')"
          />

          <text-field
              v-model="form.email"
              :error="v$.form.email.$error ? $t('client.error.email') : ''"
              :label="$t('client.email')"
          />

          <Textarea
              v-model="form.comment"
              :label="$t('client.comment')"
              :rows="5"
          />
        </template>>

        <template #modal-footer>
          <span class="btn btn-secondary" @click="close()">{{ $t('client.cancel') }}</span>
          <span class="btn btn-primary" @click="submit()">{{ $t('client.create') }}</span>
        </template>
    </b-modal>

    <message :message="msg" :link="isMsg" :isVisible=isVisibleMsg @onVisible="changeIsVisibleMsg" />
  </div>
</template>

<script src="./ModalContact.js"></script>